import { DateFormatterToken as Token } from '../../../types/functions/date-formatter-token';
import { getDayOfMonthNumeric, getDayOfMonthOrdinal, getDayOfMonthTwoDigit } from './day-of-month';
import { getDayOfWeekLong, getDayOfWeekNumeric, getDayOfWeekOrdinal, getDayOfWeekShort, getDayOfWeekTwoChar, getDayOfWeekZeroIndexed } from './day-of-week';
import { getDayOfYearNumeric, getDayOfYearOrdinal, getDayOfYearThreeDigit } from './day-of-year';
import { getHundredthsOfSecond, getMilliseconds, getTenthsOfSecond } from './fractional-seconds';
import { getHour12Numeric, getHour12TwoDigit, getHour24Numeric, getHour24TwoDigit } from './hour';
import { getMeridiemFull, getMeridiemLowerCase, getMeridiemUpperCase } from './meridiem';
import { getMinuteNumeric, getMinuteTwoDigit } from './minute';
import { getMonthLong, getMonthNumeric, getMonthOrdinal, getMonthShort, getMonthTwoDigit } from './month';
import { getOffset, getOffsetWithoutSeparator } from './offset';
import { getQuarterNumeric, getQuarterOrdinal } from './quarter';
import { getSecondNumeric, getSecondTwoDigit } from './second';
import { getMillisecondsTimestamp, getSecondsTimestamp } from './timestamp';
import { getWeekOfYearNumeric, getWeekOfYearOrdinal, getWeekOfYearTwoDigit } from './week-of-year';
import { getWeekNumberingYearNumeric, getWeekNumberingYearTwoDigit, getYearNumeric, getYearTwoDigit } from './year';
/**
 * Date formatter functions.
 * @hidden
 */
export const dateFormatters = {
    [Token.MonthNumeric]: getMonthNumeric,
    [Token.MonthOrdinal]: getMonthOrdinal,
    [Token.MonthTwoDigit]: getMonthTwoDigit,
    [Token.MonthShort]: getMonthShort,
    [Token.MonthLong]: getMonthLong,
    [Token.QuarterNumeric]: getQuarterNumeric,
    [Token.QuarterOrdinal]: getQuarterOrdinal,
    [Token.DayOfMonthNumeric]: getDayOfMonthNumeric,
    [Token.DayOfMonthOrdinal]: getDayOfMonthOrdinal,
    [Token.DayOfMonthTwoDigit]: getDayOfMonthTwoDigit,
    [Token.DayOfYearNumeric]: getDayOfYearNumeric,
    [Token.DayOfYearOrdinal]: getDayOfYearOrdinal,
    [Token.DayOfYearThreeDigit]: getDayOfYearThreeDigit,
    [Token.DayOfWeekNumeric]: getDayOfWeekNumeric,
    [Token.DayOfWeekZeroIndexed]: getDayOfWeekZeroIndexed,
    [Token.DayOfWeekOrdinal]: getDayOfWeekOrdinal,
    [Token.DayOfWeekTwoChar]: getDayOfWeekTwoChar,
    [Token.DayOfWeekShort]: getDayOfWeekShort,
    [Token.DayOfWeekLong]: getDayOfWeekLong,
    [Token.WeekOfYearNumeric]: getWeekOfYearNumeric,
    [Token.WeekOfYearOrdinal]: getWeekOfYearOrdinal,
    [Token.WeekOfYearTwoDigit]: getWeekOfYearTwoDigit,
    [Token.YearNumeric]: getYearNumeric,
    [Token.YearTwoDigit]: getYearTwoDigit,
    [Token.YearWeekNumberingNumeric]: getWeekNumberingYearNumeric,
    [Token.YearWeekNumberingTwoDigit]: getWeekNumberingYearTwoDigit,
    [Token.Hour24Numeric]: getHour24Numeric,
    [Token.Hour24TwoDigit]: getHour24TwoDigit,
    [Token.Hour12Numeric]: getHour12Numeric,
    [Token.Hour12TwoDigit]: getHour12TwoDigit,
    [Token.MinuteNumeric]: getMinuteNumeric,
    [Token.MinuteTwoDigit]: getMinuteTwoDigit,
    [Token.SecondNumeric]: getSecondNumeric,
    [Token.SecondTwoDigit]: getSecondTwoDigit,
    [Token.SecondTenth]: getTenthsOfSecond,
    [Token.SecondHundredth]: getHundredthsOfSecond,
    [Token.Millisecond]: getMilliseconds,
    [Token.MeridiemUpperCase]: getMeridiemUpperCase,
    [Token.MeridiemLowerCase]: getMeridiemLowerCase,
    [Token.MeridiemFull]: getMeridiemFull,
    [Token.Offset]: getOffset,
    [Token.OffsetWithoutSeparator]: getOffsetWithoutSeparator,
    [Token.TimestampSeconds]: getSecondsTimestamp,
    [Token.TimestampMilliseconds]: getMillisecondsTimestamp
};
//# sourceMappingURL=formatters.js.map